import fetchAPI from '../../../utils/fetchAPI';
import getSearchUrl from '../components/Map/utils/getSearchUrl';
import { Bounds } from 'google-map-react';
import { TAreaClustersClient } from 'types/Clusters';

const getClusters = ({
  bounds,
  query,
  postcode,
  distance,
  categoryId,
  minDist,
}: {
  bounds: Bounds;
  query: string;
  postcode: string;
  distance: number;
  categoryId: number;
  minDist: number;
}): Promise<TAreaClustersClient> => {
  const url: string = getSearchUrl({
    bounds,
    minDist,
    query,
    postcode,
    distance,
    categoryId,
  });
  return fetchAPI({
    url,
  });
};

export default getClusters;
